import type { TrackingAdapter } from './contracts'

export const legacyAdapter: TrackingAdapter = (name, params) => [{ name, params }]
